const ASC = 'asc';
const DESC = 'desc';

export const sortOrder = {
  ASC,
  DESC,
};

export const HASH_PARAMS_DELIMITER = '&';

export const FAVORITE_SLIDES_GROUP = 'Favorite Slides';
export const FAVORITE_SLIDES_GROUP_UI = 'Favorite ⭐️';

export const REQUESTED_IMAGE_ANALYSIS_ATTRIBUTE = 'requested_image_analysis';
export const REQUESTED_PATHOLOGY_CONSULTATION_ATTRIBUTE =
  'requested_pathology_consultation';
export const REQUESTED_IF_ATTRIBUTE = 'requested_if';
export const CONTAINS_SAMPLES_ATTRIBUTE = 'contains_samples';
export const CONTAINS_SAMPLES_AFTER_2018_ATTRIBUTE =
  'contains_samples_after_2018';
export const REQUESTED_UNSTAINED_SLIDES_ATTRIBUTE =
  'requested_unstained_slides';
export const REQUESTED_SPECIAL_STAINS_ATTRIBUTE = 'requested_special_stains';
export const REQUESTED_ANTIBODIES_ATTRIBUTE = 'requested_antibodies';
export const REQUESTED_H_AND_E_ATTRIBUTE = 'requested_h_and_e';
export const IF_SLIDES_COUNT_ATTRIBUTE = 'if_slides_count';
export const IF_SLIDES_DATA_USED_ATTRIBUTE = 'if_slides_data_used';
export const SLIDES_COUNT_ATTRIBUTE = 'slides_count';
export const SLIDES_DATA_USED_ATTRIBUTE = 'slides_data_used';
export const REQUESTED_STAINED_SLIDES_ATTRIBUTE = 'requested_stained_slides';
export const HE_SLIDES_COUNT_ATTRIBUTE = 'he_slides_count';
export const IHC_SLIDES_COUNT_ATTRIBUTE = 'ihc_slides_count';
